import { z } from "zod";

export const ZDate = z.union([
    z.date(),
    z.string().transform((v) => new Date(v)),
]);
export type ZDate = z.infer<typeof ZDate>;

export const ValidZDate = ZDate.refine((d) => !isNaN(d.getTime()), {
    message: "Invalid date",
});
export type ValidZDate = z.infer<typeof ValidZDate>;

export function monthStart(date: Date): Date {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
}

export function isoDate(date: Date): string {
    return date.toISOString().slice(0, 10);
}

export function isoMonth(date: Date): string {
    return date.toISOString().slice(0, 7);
}
